import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetWalletOwnerBankDetailsList,
	getWalletOwnerBankDetailsListReq
} from "../../redux/actions/getWalletOwnerBankDetails";

import {
	resetGetViewWalletOwnerBankDetails,
	getViewWalletOwnerBankDetailsList
} from "../../redux/actions/getViewWalletOwnerBankDetailsAction";

import {
	resetUpdateWalletDetails,
	updateWalletDetailsReq
} from "../../redux/actions/updateoraddwalletownerbankdetailsAction";

import { NavLink } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Util from "../../validation";
import SearchIcon from "@mui/icons-material/Search";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const WalletOwnerBanks = () => {
	const [open, setOpen] = React.useState(false);
	const [editOpen, setEditOpen] = React.useState(false);
	const [updateOpen, setUpdateOpen] = React.useState(false);
	const classes = useStyles();
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [btnAction, setbBtnAction] = useState("");
	const [getViewWalletOwnerBankRes, setgetViewWalletOwnerBankRes] =
		useState("");
	const [getViewWalletOwnerBankResStatus, setgetViewWalletOwnerBankResStatus] =
		useState(false);
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [getWalletOwnerBankDetailsStatus, setgetWalletOwnerBankDetailsStatus] =
		useState(false);

	const [bankname, setbankname] = useState("");
	const [getWalletOwnerBankDetailsRes, setgetWalletOwnerBankDetailsRes] =
		useState("");

	const [editOwnerBankDetailsStatus, setEditOwnerBankDetailsStatus] =
		useState(false);

	const [updateoraddwalletdetailsResp, setUpdateoraddwalletdetailsResp] =
		useState("");
	const [updateoraddwalletStatus, setUpdateoraddwalletStatus] = useState(false);

	// console.log("getWalletOwnerBankDetailsRes", getWalletOwnerBankDetailsRes);

	const [BankId, setBankId] = useState("");
	const [BankName, setBankName] = useState("");
	const [currency, setCurrency] = useState("");
	const [accountNumber, setAccountNumber] = useState("");
	const [SFBCode, setSFBCode] = useState("");
	const [sortCode, setSortCode] = useState("");
	const [routingCode, setRoutingCode] = useState("");
	const [IBANNumber, setIBANNumber] = useState("");
	const [accountHolder, setAccountHolder] = useState("");
	const [bankCountry, setBankCountry] = useState("");
	const [bankAddress, setBankAddress] = useState("");
	const [zipCode, setZipCode] = useState("");
	const [bcontactNumber, setBContactNumber] = useState("");
	const [BcontactPerson, setBcontactPerson] = useState("");
	const [isBankDefault, setIsBankDefault] = useState("");

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	var authToken = regenerateTokenRes.data.AuthToken;

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerBankDetails();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	useEffect(() => {
		resetGetViewWalletOwnerBankDetails();
		resetUpdateWalletDetails();
		resetGetWalletOwnerBankDetailsList();
	}, []);

	const getWalletOwnerBankDetailsListRes = useSelector(
		({ getWalletOwnerBankDetailsList }) => getWalletOwnerBankDetailsList
	);
	console.log("getWalletOwnerBankDetailsListRes", getWalletOwnerBankDetailsListRes);

	const getViewWalletOwnerBankDetailsRes = useSelector(
		({ getViewWalletOwnerBankDetails }) => getViewWalletOwnerBankDetails
	);

	const updateoraddwalletownerbankdetailsRes = useSelector(
		({ updateoraddwalletownerbankdetails }) => updateoraddwalletownerbankdetails
	);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleClose = () => {
		if (editOpen) {
			setOpen(false);
			setUpdateOpen(false);
			setEditOpen(false);
		} else if (open) {
			setOpen(false);
			setUpdateOpen(false);
			setEditOpen(false);
		} else if (updateOpen) {
			setOpen(false);
			setUpdateOpen(false);
			setEditOpen(false);
		}
	};

	const handleEditClose = () => {
		setEditOpen(false);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "BankId") {
			setBankId(value);
		}

		// if (name === "BcontactPerson") {
		//   setBcontactPerson(value);
		// }

		if (name === "BcontactPerson") {
			// setBcontactPerson(value);
			Util.verifyAlphabet(value)
				? setBcontactPerson(value)
				: setBcontactPerson(BcontactPerson);
		}

		if (name === "bankname") {
			// setbankname(value);
			Util.alphaNumeric(value) ? setbankname(value) : setbankname(bankname);
		}

		if (name === "currency") {
			//setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "BankName") {
			// setBankName(value);
			Util.alphaNumeric(value) ? setBankName(value) : setBankName(BankName);
		}

		if (name === "accountNumber") {
			// setAccountNumber(value);
			Util.verifyMobile(value)
				? setAccountNumber(value)
				: setAccountNumber(accountNumber);
		}

		// if (name === "accountNumber") {
		//   setAccountNumber(value);
		// }

		if (name === "SFBCode") {
			// setSFBCode(value);
			Util.alphaNumeric(value) ? setSFBCode(value) : setSFBCode(SFBCode);
		}

		if (name === "sortCode") {
			// setSortCode(value);
			Util.verifyMobile(value) ? setSortCode(value) : setSortCode(sortCode);
		}

		if (name === "routingCode") {
			// setRoutingCode(value);
			Util.verifyMobile(value)
				? setRoutingCode(value)
				: setRoutingCode(routingCode);
		}

		if (name === "IBANNumber") {
			// setIBANNumber(value);
			Util.verifyMobile(value)
				? setIBANNumber(value)
				: setIBANNumber(IBANNumber);
		}

		if (name === "accountHolder") {
			// setAccountHolder(value);
			Util.verifyAlphabet(value)
				? setAccountHolder(value)
				: setAccountHolder(accountHolder);
		}

		if (name === "bankCountry") {
			// setBankCountry(value);
			Util.verifyAlphabet(value)
				? setBankCountry(value)
				: setBankCountry(bankCountry);
		}

		if (name === "bankAddress") {
			// setBankAddress(value);
			Util.verifyAlphabet(value)
				? setBankAddress(value)
				: setBankAddress(bankAddress);
		}

		if (name === "zipCode") {
			setZipCode(value);
			Util.verifyMobile(value) ? setZipCode(value) : setZipCode(zipCode);
		}

		if (name === "bcontactNumber") {
			// setBContactNumber(value);
			Util.verifyMobile(value)
				? setBContactNumber(value)
				: setBContactNumber(bcontactNumber);
		}

		if (name === "isBankDefault") {
			// setIsBankDefault(value);
			setIsBankDefault(value == "Select Status" ? "" : value);
		}
	};

	const getWalletOwnerBankDetails = () => {
		setIsLoading(true);
		setgetWalletOwnerBankDetailsStatus(true);
		const getWalletOwnerBankListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				bankName: bankname
			}
		};

		return dispatch(
			getWalletOwnerBankDetailsListReq(getWalletOwnerBankListReq, authToken)
		);
	};

	useEffect(() => {
		if (getWalletOwnerBankDetailsStatus) {
			getWalletOwnerBankDetailsListFun();
		}
	}, [getWalletOwnerBankDetailsListRes.data.status]);

	const getWalletOwnerBankDetailsListFun = () => {
		if (getWalletOwnerBankDetailsStatus) {
			if (getWalletOwnerBankDetailsListRes.data.status == "success") {
				setgetWalletOwnerBankDetailsRes([].concat(
					getWalletOwnerBankDetailsListRes.data.bankDetailsVO
				));
				
				setIsLoading(false);
			}
			if (getWalletOwnerBankDetailsListRes.data.status == "Failed") {
				setgetWalletOwnerBankDetailsRes(getWalletOwnerBankDetailsListRes.data);
				setIsLoading(false);
				if (
					getWalletOwnerBankDetailsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerBankDetailsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getWalletOwnerBankDetailsListRes.data.status == "failed") {
				setgetWalletOwnerBankDetailsRes(getWalletOwnerBankDetailsListRes.data);
				setIsLoading(false);
				if (
					getWalletOwnerBankDetailsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerBankDetailsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getWalletOwnerBankDetailsListRes.data.status == "Not Found") {
				setgetWalletOwnerBankDetailsRes(getWalletOwnerBankDetailsListRes.data);
				setIsLoading(false);
			}
		}
	};

	useEffect(() => {
		if (getWalletOwnerBankDetailsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getWalletOwnerBankDetailsListRes.data.status]);

	//view API

	const updateHandleClickOpen = (bankId, View) => {
		setbBtnAction(View);
		setBankId(bankId);
		walletOwnerBankViewDetails(bankId);
	};

	const walletOwnerBankViewDetails = (bankId) => {
		setgetViewWalletOwnerBankResStatus(true);
		const getWalletOwnerBankViewReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				bankId: bankId
			}
		};

		return dispatch(
			getViewWalletOwnerBankDetailsList(getWalletOwnerBankViewReq, authToken)
		);
	};

	useEffect(() => {
		if (getViewWalletOwnerBankResStatus) {
			setUpdateOpen(false);
			setEditOpen(false);
			setOpen(true);
			if (getViewWalletOwnerBankDetailsRes.data.status == "Success") {
				setAccountHolder(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.accountHolder
				);
				setAccountNumber(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.accountNumber
				);
				setBankAddress(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankAddress
				);

				setBContactNumber(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankContactNo
				);
				setBcontactPerson(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankContactPerson
				);
				setBankCountry(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankCountry
				);

				setCurrency(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankCurrency
				);
				setBankName(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankName
				);
				setZipCode(getViewWalletOwnerBankDetailsRes.data.hashDataList.bankZip);

				setIBANNumber(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.ibanNumber
				);
				setSFBCode(getViewWalletOwnerBankDetailsRes.data.hashDataList.ifscCode);
				setIsBankDefault(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.isBankDefault
				);

				setRoutingCode(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.routingCode
				);
				setSortCode(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.sortCode
				);

				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
				setOpen(true);
			}
			if (getViewWalletOwnerBankDetailsRes.data.status == "Failed") {
				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getViewWalletOwnerBankDetailsRes.data.status == "failed") {
				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getViewWalletOwnerBankDetailsRes.data.status == "Not Found") {
				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
			}
		}
	}, [getViewWalletOwnerBankDetailsRes.data.status]);

	//update list

	const updateEditHandleClick = (bankId, Edit) => {
		setbBtnAction(Edit);
		// console.log(bankId);
		setOpen(false);
		setUpdateOpen(false);
		setEditOpen(true);
		setBankId(bankId);
		setEditOwnerBankDetailsStatus(true);
		walletOwnerBankViewDetails(bankId);
	};

	useEffect(() => {
		if (editOwnerBankDetailsStatus) {
			setOpen(false);
			if (getViewWalletOwnerBankDetailsRes.data.status == "Success") {
				setEditOpen(true);
				setAccountHolder(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.accountHolder
				);
				setAccountNumber(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.accountNumber
				);
				setBankAddress(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankAddress
				);

				setBContactNumber(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankContactNo
				);
				setBcontactPerson(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankContactPerson
				);
				setBankCountry(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankCountry
				);

				setCurrency(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankCurrency
				);
				setBankName(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.bankName
				);
				setZipCode(getViewWalletOwnerBankDetailsRes.data.hashDataList.bankZip);

				setIBANNumber(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.ibanNumber
				);
				setSFBCode(getViewWalletOwnerBankDetailsRes.data.hashDataList.ifscCode);
				setIsBankDefault(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.isBankDefault
				);

				setRoutingCode(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.routingCode
				);
				setSortCode(
					getViewWalletOwnerBankDetailsRes.data.hashDataList.sortCode
				);

				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
				setOpen(true);
			}
			if (getViewWalletOwnerBankDetailsRes.data.status == "Failed") {
				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getViewWalletOwnerBankDetailsRes.data.status == "failed") {
				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getViewWalletOwnerBankDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getViewWalletOwnerBankDetailsRes.data.status == "Not Found") {
				setgetViewWalletOwnerBankRes(getViewWalletOwnerBankDetailsRes.data);
			}
		}
	}, [getViewWalletOwnerBankDetailsRes.data.status]);

	//updateBankDetails api

	const updateBankDetails = () => {
		setUpdateoraddwalletStatus(true);
		const updateWalletOwnerBankViewReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			bankDetailsVO: {
				bankId: BankId,
				accountHolder: accountHolder,
				accountNumber: accountNumber,
				bankAddress: bankAddress,
				bankContactNo: bcontactNumber,
				bankContactPerson: BcontactPerson,
				bankCountry: bankCountry,
				bankCurrency: currency,
				bankName: BankName,
				bankZip: zipCode,
				ibanNumber: IBANNumber,
				ifscCode: SFBCode,
				isBankDefault: isBankDefault,
				routingCode: routingCode,
				sortCode: sortCode
			}
		};

		return dispatch(
			updateWalletDetailsReq(updateWalletOwnerBankViewReq, authToken)
		);
	};

	useEffect(() => {
		if (updateoraddwalletStatus) {
			if (updateoraddwalletownerbankdetailsRes.data.status == "success") {
				setUpdateoraddwalletdetailsResp(
					updateoraddwalletownerbankdetailsRes.data
				);

				setUpdateOpen(true);
				getWalletOwnerBankDetails();
				setOpen(false);
				setEditOpen(false);
			}
			if (updateoraddwalletownerbankdetailsRes.data.status == "Failed") {
				setUpdateoraddwalletdetailsResp(
					updateoraddwalletownerbankdetailsRes.data
				);
				setUpdateOpen(true);
				setOpen(false);
				setEditOpen(false);
				if (
					updateoraddwalletownerbankdetailsRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateoraddwalletownerbankdetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateoraddwalletownerbankdetailsRes.data.status == "failed") {
				setUpdateoraddwalletdetailsResp(
					updateoraddwalletownerbankdetailsRes.data
				);
				setUpdateOpen(true);
				setOpen(false);
				setEditOpen(false);
				if (
					updateoraddwalletownerbankdetailsRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateoraddwalletownerbankdetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateoraddwalletownerbankdetailsRes.data.status == "Not Found") {
				setUpdateoraddwalletdetailsResp(
					updateoraddwalletownerbankdetailsRes.data
				);
				setUpdateOpen(true);
				setOpen(false);
				setEditOpen(false);
			}
		}
	}, [updateoraddwalletownerbankdetailsRes.data.status]);

	return (
		<Layout>
			<Card>
				<Grid
					container
					style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
				>
					<Grid item md={3} sm={12} xs={12} lg={3}>
						<NavLink to="/index/addBankDetails">
							{/* <Button
                // startIcon={<AiOutlineUserAdd />}
                size="small"
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
              >
                Add Bank Details
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
							>
								Add Bank Details
							</CustomButton>
						</NavLink>
					</Grid>
				</Grid>

				<Grid
					container
					spacing={2}
					style={{ padding: "25px", marginTop: "2rem" }}
				>
					<Grid item xs={12} sm={12} md={4} lg={4}>
						<TextField
							autoFocus
							margin="dense"
							id="name"
							label="Bank Name"
							type="text"
							fullWidth
							variant="standard"
							value={bankname}
							name="bankname"
							onChange={handleChange}
							InputProps={{
								sx: {
								  "&:before": { borderBottomColor: "gray" }, // before focus
								  "&:after": { borderBottomColor: "gray" },  // after focus
								},
							  }}
							  InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							  }}
						/>
					</Grid>

					<Grid item xs={12} sm={12} md={4} lg={4} container>
						<Grid>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "7px",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getWalletOwnerBankDetails}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getWalletOwnerBankDetails}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Grid>
			</Card>

			{isLoading ? (
				<LoadingSpinner />
			) : getWalletOwnerBankDetailsRes.length == undefined ||
				getWalletOwnerBankDetailsRes.status == "Failed" ||
				getWalletOwnerBankDetailsRes.status == "Not Found" ||
				!getWalletOwnerBankDetailsStatus ? (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography
								variant="body1"
								style={{ fontWeight: "700" }}
								className="themeText"
							>
								Wallet Owner Banks
							</Typography>
						</Grid>

						<Grid xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="my-3 tableHeaderColor"
								variant="secondary"
								style={{ color: "white" }}
							>
								No Records Found!
							</Alert>
						</Grid>
					</Grid>
				</Card>
			) : (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography
								variant="body1"
								style={{ fontWeight: "700" }}
								className="themeText"
							>
								Wallet Owner Banks
							</Typography>
						</Grid>
						<TableContainer component={Paper} className="my-3">
							<Table
								className={classes.table}
								size="small"
								aria-label="a dense table"
							>
								<TableHead>
									<TableRow className="tableHeaderColor">
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Bank Name
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Currency
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Account Holder
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Is Bank Default
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Action
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{getWalletOwnerBankDetailsRes &&
										[]
											.concat(getWalletOwnerBankDetailsRes)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">{row.bankName}</TableCell>
													<TableCell align="center">
														{row.bankCurrency}
													</TableCell>
													<TableCell align="center">
														{row.accountHolder}
													</TableCell>
													<TableCell align="center">
														{row.isBankDefault}
													</TableCell>

													<TableCell align="center" style={{ display: "flex" }}>
														<Tooltip title="View">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	updateHandleClickOpen(row.bankId, "View")
																}
															>
																{
																	<VisibilityIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
														</Tooltip>

														<Tooltip title="Edit">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	updateEditHandleClick(row.bankId, "Edit")
																}
															>
																{
																	<EditIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
														</Tooltip>
													</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
							<TablePagination
								rowsPerPageOptions={[5, 10, 25]}
								component="div"
								count={getWalletOwnerBankDetailsRes.length}
								rowsPerPage={rowsPerPage}
								page={page}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/>
						</TableContainer>
					</Grid>
				</Card>
			)}

			{btnAction == "View" && (
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle>View Customer</DialogTitle>
						<DialogContent>
							{/* {Object.entries(getViewWalletOwnerBankRes).map(([key, value]) => (
              <TextField
                autoFocus
                margin="dense"
                label={
                  key
                    ? key.replace(/([a-z])([A-Z])/, "$1 $2").toUpperCase()
                    : ""
                }
                type="name"
                fullWidth
                variant="standard"
                value={value || ""}
                disabled
              />
            ))} */}

							<TextField
								autoFocus
								margin="dense"
								label="Bank ID"
								type="name"
								fullWidth
								variant="standard"
								value={BankId || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								autoFocus
								margin="dense"
								label="Bank Name"
								type="name"
								fullWidth
								variant="standard"
								value={BankName || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Currency"
								type="name"
								fullWidth
								variant="standard"
								value={currency || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Account Number"
								type="name"
								fullWidth
								variant="standard"
								value={accountNumber || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="SWIFT/IFSC/BIC Code"
								type="name"
								fullWidth
								variant="standard"
								value={SFBCode || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							{/* <TextField
                autoFocus
                margin="dense"
                label="SWIFT/IFSC/BIC Code"
                type="name"
                fullWidth
                variant="standard"
                value={SFBCode || ""}
                disabled
              /> */}

							<TextField
								autoFocus
								margin="dense"
								label="Sort Code"
								type="name"
								fullWidth
								variant="standard"
								value={sortCode || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="ABA Routing Code"
								type="name"
								fullWidth
								variant="standard"
								value={routingCode || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="IBAN Number"
								type="name"
								fullWidth
								variant="standard"
								value={IBANNumber || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Account Holder"
								type="name"
								fullWidth
								variant="standard"
								value={accountHolder || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Country"
								type="name"
								fullWidth
								variant="standard"
								value={bankCountry || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Address"
								type="name"
								fullWidth
								variant="standard"
								value={bankAddress || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Zip Code"
								type="name"
								fullWidth
								variant="standard"
								value={zipCode || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Contact Number"
								type="name"
								fullWidth
								variant="standard"
								value={bcontactNumber || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Contact Person"
								type="name"
								fullWidth
								variant="standard"
								value={BcontactPerson || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Is Bank Default"
								type="name"
								fullWidth
								variant="standard"
								value={isBankDefault || ""}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{btnAction == "Edit" && (
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Update Customer</DialogTitle>
						<DialogContent>
							{/* {Object.entries(getViewWalletOwnerBankRes).map(([key, value]) => (
              <TextField
                autoFocus
                margin="dense"
                label={
                  key
                    ? key.replace(/([a-z])([A-Z])/, "$1 $2").toUpperCase()
                    : ""
                }
                type="name"
                fullWidth
                variant="standard"
                value={value || ""}
                disabled
              />
            ))} */}

							<TextField
								autoFocus
								name="BankName"
								margin="dense"
								label="Bank Name"
								type="name"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={BankName || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								select
								autoFocus
								margin="dense"
								label="Currency"
								name="currency"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								// value={currency || ""}
								defaultValue={currency || "Select Currency"}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>

							<TextField
								autoFocus
								name="accountNumber"
								margin="dense"
								label="Account Number"
								type="name"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={accountNumber || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="SWIFT/IFSC/BIC Code"
								type="text"
								fullWidth
								name="SFBCode"
								variant="standard"
								onChange={handleChange}
								value={SFBCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Sort Code"
								name="sortCode"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={sortCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="ABA Routing Code(US)"
								type="text"
								fullWidth
								name="routingCode"
								variant="standard"
								onChange={handleChange}
								value={routingCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="IBAN Number"
								name="IBANNumber"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={IBANNumber || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Account Holder"
								type="text"
								name="accountHolder"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={accountHolder || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Country"
								name="bankCountry"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={bankCountry || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Address"
								type="text"
								name="bankAddress"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={bankAddress || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Zip Code"
								name="zipCode"
								onChange={handleChange}
								type="text"
								fullWidth
								variant="standard"
								value={zipCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Contact Number"
								type="text"
								name="bcontactNumber"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={bcontactNumber || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								autoFocus
								margin="dense"
								label="Bank Contact Person"
								type="text"
								fullWidth
								name="BcontactPerson"
								variant="standard"
								onChange={handleChange}
								value={BcontactPerson || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>

							<TextField
								select
								autoFocus
								margin="dense"
								label="Is Bank Default"
								name="isBankDefault"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								defaultValue={isBankDefault || "Select Status"}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Status">Select Status</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => handleClose()}
							>
								Close
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => updateBankDetails()}
							>
								Save
							</CustomButton>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={updateBankDetails}
              >
                Save
              </Button>

              <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleClose}
              >
                Close
              </Button> */}
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateOpen && (
				<div>
					<Dialog open={updateOpen} onClose={handleClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							{updateoraddwalletdetailsResp.status == "success" ? (
								<img src={success} alt="" width="100px" className="my-2" />
							) : (
								<img src={failed} alt="" width="100px" className="my-2" />
							)}
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								{updateoraddwalletdetailsResp.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>

							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</Layout>
	);
};

export default WalletOwnerBanks;
